import { RestUrl } from "../common/cyan.types";

export class DocsAuditUrl {
  public static paginateDocsAudits: RestUrl = ["GET", "/audits"];
}
